import React, { useState, useEffect } from 'react'
import cx from 'classnames'
import styles from './neetmocktest.module.css'
import neetregdesktop from '../../assets/neet_reg_desktop.png'
import neetmodelreg from '../../assets/neet_model_reg.png'


const NeetMocksteps = () => {

    return (
        <div>
            <div
                className={`container ${styles.register_wrapper}`}
                id="how-it-works"
            >
                <div className={`${styles.reg_inner}`}>
                    <div className={`${styles.reg_imagestatic}`}>
                        <img src={neetregdesktop} alt="" />
                    </div>
                    <div className={`${styles.reg_imagegif}`}>
                        <img
                            src={neetmodelreg}
                            alt=""
                            className="img-fluid"
                        />
                        <div
                            className={`${styles.registration_section}`}
                        ></div>
                    </div>

                    <div className={`${styles.registration_section}`}>
                        <div className={`${styles.reg_content}`}>
                            <h3>How to register?</h3>
                            <p className={`${styles.reg_subtitle}`}>
                                In just 3-step process
                            </p>
                            <div className={`${styles.reg_steps}`}>
                                <div className={`${styles.reg_step}`}>
                                    <div
                                        className={`${styles.reg_step_number}`}
                                    >
                                        1
                                    </div>
                                    <p>Verify your mobile number</p>
                                </div>
                                <div className={`${styles.reg_step}`}>
                                    <div
                                        className={`${styles.reg_step_number}`}
                                    >
                                        2
                                    </div>
                                    <p>Submit your details</p>
                                </div>
                                <div className={`${styles.reg_step}`}>
                                    <div
                                        className={`${styles.reg_step_number}`}
                                    >
                                        3
                                    </div>
                                    <p>
                                    Registration completed
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NeetMocksteps